import { render, staticRenderFns } from "./pricelisthelp.vue?vue&type=template&id=b289fcca&"
import script from "./pricelisthelp.vue?vue&type=script&lang=js&"
export * from "./pricelisthelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b289fcca')) {
      api.createRecord('b289fcca', component.options)
    } else {
      api.reload('b289fcca', component.options)
    }
    module.hot.accept("./pricelisthelp.vue?vue&type=template&id=b289fcca&", function () {
      api.rerender('b289fcca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2y8fNzgd9weJ3/JS/pricelisthelp.vue"
export default component.exports